import React from "react";

// Normalise status values to modern, readable pastel states
const getStatusPillStyle = (text) => {
  const lower = (text || "").toLowerCase();
  if (lower === "positive" || lower === "pass" || lower === "verified" || lower === "approved") {
    return { bg: "#dcfce7", color: "#15803d", border: "1px solid #bbf7d0" }; // Soft green
  }
  if (lower === "negative" || lower === "fail" || lower === "failed" || lower === "rejected") {
    return { bg: "#fee2e2", color: "#b91c1c", border: "1px solid #fecaca" }; // Soft red
  }
  if (lower === "pending" || lower === "in progress" || lower === "defer") {
    return { bg: "#fef9c3", color: "#854d0e", border: "1px solid #fef08a" }; // Soft amber
  }
  return { bg: "#f1f5f9", color: "#475569", border: "1px solid #e2e8f0" }; // Soft gray fallback
};

/**
 * Section-level heading card used before every form section.
 * Left accent strip + title + subtitle + status pill.
 * Per-section colored backgrounds via props, with soft pastel status pills.
 */
function CustomHeading({
  title,
  subtitle,
  buttonText,
  icon: Icon,
  buttonColor,       // kept for API compat — no longer used for pill
  background = "#eef3f8",
  borderColor = "#024e5a",
}) {
  const pill = getStatusPillStyle(buttonText);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "space-between",
        gap: 16,
        background: background,
        borderRadius: 12,
        borderLeft: `4px solid ${borderColor}`,
        padding: "14px 18px",
        marginBottom: 16,
        marginTop: 16,
      }}
    >
      {/* Left: title + subtitle */}
      <div style={{ flex: 1, minWidth: 0 }}>
        <h5
          style={{
            margin: 0,
            fontWeight: 700,
            fontSize: window.innerWidth > 1800 ? 17 : 14,
            color: "#0f172a",
            lineHeight: 1.35,
            letterSpacing: ".005em",
          }}
        >
          {title}
        </h5>
        {subtitle && (
          <p
            style={{
              margin: "4px 0 0",
              fontSize: 12,
              color: "#475569",
              lineHeight: 1.5,
            }}
          >
            {subtitle}
          </p>
        )}
      </div>

      {/* Right: soft-pastel status pill */}
      {/* {buttonText && (
        <span
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 5,
            background: pill.bg,
            color: pill.color,
            border: pill.border,
            fontSize: 11,
            fontWeight: 700,
            padding: "4px 12px",
            borderRadius: 20,
            letterSpacing: ".03em",
            whiteSpace: "nowrap",
            flexShrink: 0,
          }}
        >
          {Icon && <Icon size={12} strokeWidth={2.5} />}
          {buttonText}
        </span>
      )} */}
    </div>
  );
}

export default CustomHeading;
